/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import Grid from "@mui/material/Grid";
import axios from "axios";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";

import { useMaterialUIController } from "context";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { isValidPhone } from "utils/Constant";


function UpdateDriver() {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [errors, setErrors] = useState({});

  const row_data = location.state || {};
  const handleBlur = (event) => {
    const { name, value } = event.target;

    setErrors((prev) => {
      const next = { ...prev };

      switch (name) {
        case "first_name":
          if (!allowOnlyAlphanumericAndSpace(value)) {
            next.first_name = "First name should contain only alphabets";
          } else delete next.first_name;
          break;

        case "last_name":
          if (!allowOnlyAlphanumericAndSpace(value)) {
            next.last_name = "Last name should contain only alphabets";
          } else delete next.last_name;
          break;

        default:
          break;
      }

      return next;
    });
  };

  const getInitialValues = () => ({
    first_name: row_data.firstName || "",
    last_name: row_data.lastName || "",
    phone_number: row_data.phoneNumber || "",
    email: row_data.email || "",
    gender: row_data.gender || "",
    date_of_birth: formatDate(row_data.dob) || "",
    state: row_data.state || "",
    city: row_data.city || "",
    rfidTag: row_data.rfidTag || "",
    id: row_data._id,
  });
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [day, month, year] = dateString.split("/");
    if (!month || !year) {
      return "";
    }

    const paddedDay = day.padStart(2, "0");
    const paddedMonth = month.padStart(2, "0");

    return `${year}-${paddedMonth}-${paddedDay}`;
  };

  const [values, setValues] = useState(getInitialValues);

  useEffect(() => {
    setValues(getInitialValues);
  }, [row_data]);

  const createUser = (
    first_name,
    last_name,
    phone_number,
    email,
    gender,
    dob,
    state,
    city,
    rfidTag
  ) => {
    const formattedDobValue = dayjs(dob).format("DD/MM/YYYY");
    const payload = {
      firstName: first_name,
      lastName: last_name,
      state: values.state,
      city: values.city,
      gender: gender,
      dob: formattedDobValue,
      rfidTag: values.rfidTag,
      phoneNumber: phone_number
    };

    axios({
      method: "patch",
      url: process.env.REACT_APP_BASEURL + "users/user/" + values.rfidTag,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,

    })
      .then((response) => {
        if (response.data.success === true) {
          enqueueSnackbar(response.data.message, { variant: "success" });
          navigate("/Driver-Management");
        } else {
          enqueueSnackbar(response.data.message, { variant: "error" });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      });
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (values.first_name === "" || values.last_name === "") {
      return enqueueSnackbar("All fields are necessary", { variant: "error" });
    }
    createUser(
      values.first_name,
      values.last_name,
      values.phone_number,
      values.email,
      values.gender,
      values.date_of_birth,
      values.state,
      values.city,
      values?.rfidTag,
    );
  };

  const reset = (event) => {
    event.preventDefault();
    setValues(getInitialValues());
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Personal information
                </MDTypography>
              </MDBox>

              <MDBox p={4} component="form" role="form">
                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="First Name"
                    value={values.first_name}
                    name="first_name"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.first_name}
                    helperText={errors.first_name}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        color: "error.main",
                      },
                      "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "error.main",
                      },
                    }}
                  />
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Last Name"
                    value={values.last_name}
                    name="last_name"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!errors.last_name}
                    helperText={errors.last_name}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        color: "error.main",
                      },
                      "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "error.main",
                      },
                    }}
                  />
                </MDBox>
                <MDBox p={1}>
                  <div className="disabled-input-wrapper">
                    <MDInput
                      disabled
                      type="text"
                      label="Driver ID"
                      value={values.rfidTag}
                      name="phone_number"
                      margin="dense"
                      fullWidth
                      onChange={handleChange}
                    />
                  </div>
                </MDBox>
                <style>
                  {`

                  .disabled-input-wrapper div{
                    background-color: ${controller.darkMode ? "#1a2035" : "#f0f2f5"} !important;
                          }
                  `}
                </style>
                <MDBox p={1}>
                  <div >
                    <MDInput
                
                      type="email"
                      label="E-mail ID"
                      value={values.email}
                      name="email"
                      placeholder="username@gmail.com"
                      pattern=".+@+.+.com"
                      margin="dense"
                      fullWidth
                      onChange={handleChange}
                    />
                  </div>
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="tel"
                    label="Phone Number"
                    value={values.phone_number}
                    name="phone_number"
                    fullWidth
                    onChange={handleChange}
                    onBlur={(e) => {
                      const value = e.target.value;

                      setErrors((prev) => ({
                        ...prev,
                        phone_number: isValidPhone(value)
                          ? ""
                          : "Enter a valid Phone Number",
                      }));
                    }}
                    error={Boolean(errors.phone_number)}
                    helperText={errors.phone_number}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        color: "error.main",
                      },
                      "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "error.main",
                      },
                    }}
                  />
                </MDBox>

                <MDBox p={1}>
                  {/* <MDInput
                    
                    type="text"
                    label="Gender"
                    value={values.gender}
                    name="gender"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  /> */}
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Gender
                    </InputLabel>
                    <Select
                      sx={{
                        height: 50,
                      }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={values.gender}
                      label="Gender"
                      name="gender"
                      onChange={handleChange}
                    >
                      <MenuItem value={"Male"}>Male</MenuItem>
                      <MenuItem value={"Female"}>Female</MenuItem>
                      <MenuItem value={"Other"}>Other</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox p={1}>
                  <FormControl fullWidth variant="outlined" margin="dense">
                    <InputLabel shrink={true} htmlFor="date-of-birth">
                      Date Of Birth
                    </InputLabel>
                    <OutlinedInput
                      id="date-of-birth"
                      type="date"
                      label="Date Of Birth"
                      value={values.date_of_birth}
                      name="date_of_birth"
                      onChange={handleChange}
                      notched={true}
                    />
                  </FormControl>
                </MDBox>

                <Grid
                  container
                  direction="row"
                  justifyContent="space-around"
                  p={2}
                >
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={reset}
                  >
                    Reset
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={handleSubmit}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default UpdateDriver;
